var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUp(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.496 12.96V32H.992V12.96h5.504zM19.36.032c.448-.128 1.312.224 1.632.448 2.016 1.536 2.112 4.48 1.472 6.432l-.224.736c-.448 1.344-1.216 4.064-.224 4.704.672.416 2.24.32 3.584.224l.48-.032c1.728-.128 2.56-.032 3.104.064.896.128 1.376.288 1.696.608.512.448.864 1.216.96 2.112.096 1.472-.576 2.144-.576 2.592S32 19.2 32 20.48s-1.12 2.272-1.248 2.88.384 1.504-.064 2.752c-.416 1.152-1.152 1.248-1.536 2.112-.128.256-.192.672-.224.928a1.93 1.93 0 01-.192.608c-.64 1.312-1.568 1.632-2.912 1.824-1.536.224-2.144.128-3.648.096-1.856 0-3.232-.224-5.024-.48-1.664-.256-2.848-.64-4.448-1.024-1.44-.32-2.752-.48-3.808-.544h-.288V14.304c.352-.128.704-.256 1.024-.448l.448-.224c1.216-.64 5.888-2.784 8.064-9.408.288-.96.48-2.112.608-2.848l.064-.448c.096-.544.16-.768.544-.896z"
  })));
}

export default SvgThumbsUp;